var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from 'axios';
import pako from 'pako';
var API_URL = 'https://api.challengerinsights.gg';
export function getWinrates(X) {
    return __awaiter(this, void 0, void 0, function () {
        var url, response, winrates, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = "".concat(API_URL, "/predict");
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, axios.post(url, X)];
                case 2:
                    response = _a.sent();
                    winrates = response.data;
                    return [2 /*return*/, winrates.map(function (winrate) { return winrate * 100; })];
                case 3:
                    error_1 = _a.sent();
                    console.log("Error in prediction:", error_1);
                    return [2 /*return*/, null];
                case 4: return [2 /*return*/];
            }
        });
    });
}
export function logGame(riotId) {
    return __awaiter(this, void 0, void 0, function () {
        var error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, axios.post("".concat(API_URL, "/log-game"), { riotId: riotId })];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    error_2 = _a.sent();
                    console.log('Failed to log game:', error_2);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    });
}
export function saveGame(compressedGameData, riotId) {
    return __awaiter(this, void 0, void 0, function () {
        var response, _a, url, game_id, uploadResponse, error_3;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, axios.post("".concat(API_URL, "/get-upload-url"), { riotId: riotId })];
                case 1:
                    response = _b.sent();
                    if (response.status !== 200) {
                        throw new Error("Failed to get upload URL: ".concat(response.data.error));
                    }
                    _a = response.data, url = _a.url, game_id = _a.game_id;
                    return [4 /*yield*/, axios.put(url, compressedGameData, {
                            headers: { 'Content-Type': 'application/gzip' }
                        })];
                case 2:
                    uploadResponse = _b.sent();
                    if (uploadResponse.status !== 200) {
                        throw new Error('Failed to upload file');
                    }
                    return [2 /*return*/, game_id];
                case 3:
                    error_3 = _b.sent();
                    console.error('Error uploading file:', error_3);
                    return [2 /*return*/, null];
                case 4: return [2 /*return*/];
            }
        });
    });
}
export function getGame(gameId) {
    return __awaiter(this, void 0, void 0, function () {
        var downloadUrlApi, urlResponse, downloadUrl, response, decompressedData, gameData, error_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    downloadUrlApi = "".concat(API_URL, "/get-download-url/game/").concat(gameId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, axios.get(downloadUrlApi)];
                case 2:
                    urlResponse = _a.sent();
                    if (urlResponse.status !== 200) {
                        throw new Error("Failed to retrieve download URL: ".concat(urlResponse.data.error || urlResponse.statusText));
                    }
                    downloadUrl = urlResponse.data.url;
                    return [4 /*yield*/, axios.get(downloadUrl, { responseType: 'arraybuffer' })];
                case 3:
                    response = _a.sent();
                    if (response.status === 200) {
                        decompressedData = pako.ungzip(new Uint8Array(response.data), { to: 'string' });
                        gameData = JSON.parse(decompressedData);
                        return [2 /*return*/, gameData];
                    }
                    else {
                        throw new Error('Download failed: ' + response.statusText);
                    }
                    return [3 /*break*/, 5];
                case 4:
                    error_4 = _a.sent();
                    console.error('Failed to download file:', error_4);
                    return [2 /*return*/, null];
                case 5: return [2 /*return*/];
            }
        });
    });
}
